<script setup lang="ts">
  import { Modal } from 'bootstrap'

  import { ref, onMounted } from 'vue'

  import Icon from '@/components/Atoms/Icon.vue'
  import { useModalControl } from '../store/pinia/useModalControl.store'
  import usePluginCertificatePasswordModal from '../composables/usePluginCertificatePasswordModal'
  import { wait } from '@/utils/helpers'
  import useSetNewPassword from '../composables/useSetNewPassword'

  const emit = defineEmits(['chosePasswordConfirm'])
  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const props = defineProps({
    isDifferentPass: {
      type: Boolean,
      default: false,
    },
  })

  onMounted(() => {
    modal.value = new Modal('#modal-plugin-certificate-password-tip', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function hide() {
    modal.value?.hide()
  }

  function show() {
    modal.value?.show()
  }

  async function advanceNextStep(): Promise<void> {
    const modalControlStore = useModalControl()
    const { hideSetNewPasswordModal, showSetNewPasswordModal } =
      useSetNewPassword()

    hide()

    if (!props.isDifferentPass) {
      return wait(500).finally(() => {
        emit('chosePasswordConfirm')
      })
    }

    return modalControlStore.show({
      modalId: 'setNewPasswordModal',
      hide: hideSetNewPasswordModal,
      show: showSetNewPasswordModal,
    })
  }

  async function comeBack(): Promise<void> {
    const modalControlStore = useModalControl()
    const {
      showPluginCertificatePasswordModal,
      hidePluginCertificatePasswordModal,
    } = usePluginCertificatePasswordModal()

    modalControlStore.show({
      modalId: 'pluginCertificatePasswordModal',
      show: showPluginCertificatePasswordModal,
      hide: hidePluginCertificatePasswordModal,
    })
  }

  defineExpose({ hide, show })
</script>

<template>
  <div
    id="modal-plugin-certificate-password-tip"
    class="modal modal-md fade"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header pb-3 border-bottom">
          <h5 class="modal-title plugin-modal-title text-danger">Atenção!</h5>
        </div>
        <div class="modal-body py-3">
          <img alt="modo de isolamento" src="../assets/isolation-mode.svg" />
          <div v-if="isDifferentPass" class="mt-5">
            <p class="fs-6 text-start">
              Você escolheu <strong>criar uma senha</strong> para usar seu
              Certificado Digital.
            </p>
            <p class="fs-6 text-start pt-3">
              <strong>Essa senha não substitui a senha de emissão.</strong>
            </p>
            <p class="fs-6 text-start pt-3">
              Tem certeza de que deseja continuar?
            </p>
          </div>
          <div v-else class="mt-5">
            <p class="fs-6 text-start">
              Você escolheu a
              <strong>senha de emissão para ser a senha de uso</strong>
              do seu Certificado Digital.
            </p>
            <p class="fs-6 text-start pt-3">
              Tem certeza de que deseja continuar?
            </p>
          </div>
        </div>
        <div class="modal-footer py-3">
          <button class="btn btn-secondary" type="button" @click="comeBack">
            <span>Alterar escolha </span>
          </button>
          <button
            class="btn btn-primary"
            type="button"
            @click="advanceNextStep"
          >
            <span>Desejo continuar</span>
            <Icon class="ms-2" name="arrow-right"></Icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .plugin-modal-title {
    font-size: 1.5rem;
  }

  .label-text-left {
    text-align: left !important;
  }

  .square-circle-container {
    min-width: 16px;
    min-height: 16px;
  }

  .img-container {
    width: 180px;
    height: auto;
  }
</style>
